export const H5_MEDIA = '(max-width: 768px)';
const H5_CLASS = 'is-h5';

export function isH5() {
	if (typeof window !== 'undefined' && window.matchMedia) {
		return window.matchMedia(H5_MEDIA).matches;
	}
	return typeof document !== 'undefined' && document.documentElement.classList.contains(H5_CLASS);
}

export function installH5Layout() {
	if (typeof window === 'undefined' || !window.matchMedia) {
		return;
	}
	const mql = window.matchMedia(H5_MEDIA);
	const apply = () => {
		const on = !!mql.matches;
		document.documentElement.classList.toggle(H5_CLASS, on);
		if (document.body) {
			document.body.classList.toggle(H5_CLASS, on);
		}
	};
	apply();
	if (mql.addEventListener) {
		mql.addEventListener('change', apply);
	} else if (mql.addListener) {
		mql.addListener(apply);
	}
}
